import {
  DEFAULT_THEME_ID,
  LuigiThemingService,
  staticThemes,
} from '../../service/luigiNodes/luigi-theming.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  signal,
} from '@angular/core';
import {
  ListBylineDirective,
  ListComponent,
  ListContentDirective,
  ListItemComponent,
  ListLinkDirective,
  ListThumbnailDirective,
  ListTitleDirective,
} from '@fundamental-ngx/core/list';
import {
  TabListComponent,
  TabPanelComponent,
} from '@fundamental-ngx/core/tabs';
import { addInitListener, sendCustomMessage } from '@luigi-project/client';
import { I18nService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-details',
  imports: [
    TabListComponent,
    TabPanelComponent,
    ListComponent,
    ListItemComponent,
    ListLinkDirective,
    ListThumbnailDirective,
    ListContentDirective,
    ListTitleDirective,
    ListBylineDirective,
  ],
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSelectorComponent implements OnInit {
  selectedTheme = DEFAULT_THEME_ID;
  themes = staticThemes;
  readonly themeTabTitle = signal('');

  constructor(
    private ref: ChangeDetectorRef,
    private i18nService: I18nService,
    private luigiThemingService: LuigiThemingService,
  ) {}

  async ngOnInit() {
    addInitListener(async () => {
      this.selectedTheme =
        await this.luigiThemingService.getStoredThemeOrDefault();
      this.ref.detectChanges();
    });
    this.themeTabTitle.set(
      await this.i18nService.getTranslationAsync('THEME_TAB'),
    );
  }

  selectTheme(selectedTheme: string): void {
    this.selectedTheme = selectedTheme;
    this.ref.detectChanges();
    sendCustomMessage({
      id: 'luigi.updateUserSettings',
      data: { selectedTheme: this.selectedTheme },
    });
  }
}
